module.exports = __webpack_public_path__ + "img/legende250.15cbfdf1.jpg";